"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lazyTriageActions = require("owa-mail-triage-action");
var markReadActions = require("owa-mail-mark-read-actions");
var folderIdToName_1 = require("owa-session-store/lib/utils/folderIdToName");
var owa_mail_moveto_control_1 = require("owa-mail-moveto-control");
var getFoldersForMoveTo_1 = require("owa-mail-store/lib/utils/getFoldersForMoveTo");
var getInstrumentationContextsFromTableView_1 = require("owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView");
var isReadingPaneBottom_1 = require("owa-mail-reading-pane-store/lib/utils/isReadingPaneBottom");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var owa_filterable_menu_1 = require("owa-filterable-menu");
var owa_group_selection_1 = require("owa-group-selection");
var owa_mail_filterable_menu_behavior_1 = require("owa-mail-filterable-menu-behavior");
var owa_mail_reading_pane_store_1 = require("owa-mail-reading-pane-store");
var owa_mail_rule_view_1 = require("owa-mail-rule-view");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_immersive_reader_store_1 = require("owa-immersive-reader-store");
var owa_mail_message_actions_1 = require("owa-mail-message-actions");
// Used as a key for divider, because IContextualMenuItem requires each element to have a different key
var dividerKey = 0;
/**
 * Get an array of filterable menu items for mail list context menu
 * @param rowKeys the row keys to show the context menu
 * @param tableViewId the id of the table that contains these rows
 * @return the context menu items
 */
function getFilterableMailListContextMenuItems(rowKeys, tableViewId) {
    var shouldShowBehaviorMap = owa_mail_filterable_menu_behavior_1.getMailMenuItemShouldShowMap();
    return [
        // Reply/Reply all/Forward
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.itemHeaderReply, null /* icon */, function () { return onReplyRow(rowKeys[0], tableViewId); }, shouldShowBehaviorMap[21 /* Reply */]),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.itemHeaderReplyAll, null /* icon */, function () { return onReplyAllRow(rowKeys[0], tableViewId); }, shouldShowBehaviorMap[25 /* SingleSelection */]),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.itemHeaderForward, null /* icon */, function () { return onForwardRow(rowKeys[0], tableViewId); }, shouldShowBehaviorMap[25 /* SingleSelection */]),
        newDivider(function () {
            return (shouldShowBehaviorMap[14 /* Move */]() ||
                shouldShowBehaviorMap[5 /* Delete */]() ||
                shouldShowBehaviorMap[22 /* Restore */]() ||
                shouldShowBehaviorMap[2 /* Archive */]() ||
                shouldShowBehaviorMap[6 /* EmptyFolder */]());
        }),
        // Delete/Restore/Archive
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.deleteItem, null /* icon */, function () { return onDeleteClicked(rowKeys, tableViewId); }, shouldShowBehaviorMap[5 /* Delete */]),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.restoreItem, null /* icon */, function () {
            return lazyTriageActions.lazyRestoreConversationsAction.importAndExecute(rowKeys, tableViewId);
        }, shouldShowBehaviorMap[22 /* Restore */]),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.archive, null /* icon */, function () { return onArchiveClicked(rowKeys, tableViewId); }, shouldShowBehaviorMap[2 /* Archive */]),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.move, null, // no - icon
        function () { }, shouldShowBehaviorMap[14 /* Move */], null /* displayOption*/, false /* disabled */, createMoveToSubMenu(rowKeys, tableViewId, shouldShowBehaviorMap)),
        // Empty folder
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.deleteItem, null /* icon */, function () {
            var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
            lazyTriageActions.lazyEmptyTableView.importAndExecute(tableView, false /*isExplicitSoftDelete*/, 'ContextLV', tableView.virutalSelectAllExclusionList);
        }, shouldShowBehaviorMap[6 /* EmptyFolder */]),
        newDivider(function () {
            return (shouldShowBehaviorMap[12 /* MarkAsRead */]() ||
                shouldShowBehaviorMap[13 /* MarkAsUnread */]() ||
                shouldShowBehaviorMap[7 /* Flag */]() ||
                shouldShowBehaviorMap[28 /* Unflag */]() ||
                shouldShowBehaviorMap[19 /* Pin */]() ||
                shouldShowBehaviorMap[29 /* Unpin */]());
        }),
        // Mark as read/unread
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.markAsRead, null /* icon */, function () { return onMarkAsReadClicked(tableViewId); }, shouldShowBehaviorMap[12 /* MarkAsRead */]),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.markAsUnread, null /* icon */, function () { return onMarkAsUnreadClicked(tableViewId); }, shouldShowBehaviorMap[13 /* MarkAsUnread */]),
        // Flag/Unflag
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.flag, null /* icon */, function () { return markRowsAsFlagged(rowKeys, tableViewId); }, shouldShowBehaviorMap[7 /* Flag */]),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.unflag, null /* icon */, function () { return markRowsAsNotFlagged(rowKeys, tableViewId); }, shouldShowBehaviorMap[28 /* Unflag */]),
        // Pin/unpin
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.pin, null /* icon */, function () { return markRowsPinnedUnpinned(rowKeys, tableViewId, true /* shouldMarkAsPinned */); }, shouldShowBehaviorMap[19 /* Pin */]),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.unpin, null /* icon */, function () { return markRowsPinnedUnpinned(rowKeys, tableViewId, false /* shouldMarkAsPinned */); }, shouldShowBehaviorMap[29 /* Unpin */]),
        newDivider(function () {
            return (shouldShowBehaviorMap[10 /* MarkAsJunk */]() ||
                shouldShowBehaviorMap[11 /* MarkAsNotJunk */]() ||
                shouldShowBehaviorMap[3 /* Block */]());
        }),
        // Junk/Not junk/Block
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.markAsJunk, null /* icon */, function () { return onJunkNotJunkClicked(rowKeys, tableViewId, true /* isJunkValueToSet */); }, shouldShowBehaviorMap[10 /* MarkAsJunk */]),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.markAsNotJunk, null /* icon */, function () { return onJunkNotJunkClicked(rowKeys, tableViewId, false /* isJunkValueToSet */); }, shouldShowBehaviorMap[11 /* MarkAsNotJunk */]),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.block, null /* icon */, function () { return onBlockClicked(rowKeys, tableViewId); }, shouldShowBehaviorMap[3 /* Block */]),
        newDivider(function () {
            return (shouldShowBehaviorMap[8 /* InboxRule */]() ||
                shouldShowBehaviorMap[24 /* ShowInImmersiveReader */]());
        }),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.createRule, null, // no - icon
        function () { return onCreateRuleClicked(rowKeys[0], tableViewId); }, shouldShowBehaviorMap[8 /* InboxRule */], null /* displayOption */),
        // Show in immersive reader
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.showInImmersiveReader, null, // no - icon
        function () {
            onShowInImmersiveReaderClicked(rowKeys[0], tableViewId);
        }, shouldShowBehaviorMap[24 /* ShowInImmersiveReader */]),
        new owa_filterable_menu_1.FilterableMenuItem(owa_mail_strings_1.default.openInNewTab, null, // no - icon
        function () { return onOpenInNewTabClicked(rowKeys, tableViewId); }, shouldShowBehaviorMap[18 /* OpenInNewTab */]),
    ];
}
exports.default = getFilterableMailListContextMenuItems;
/**
 * Create the move to sub menu
 * @param rowKeys the rowKeys for the rows to be moved
 * @param tableViewId the original table view id to move from
 */
function createMoveToSubMenu(rowKeys, tableViewId, shouldShowBehaviorMap) {
    var moveToSubMenu = [];
    //#region FocusedOther Actions
    if (shouldShowBehaviorMap[15 /* MoveToFocusedInbox */]()) {
        moveToSubMenu.push({
            key: 'moveTo' + owa_mail_strings_1.default.moveToFocusedInboxText,
            name: owa_mail_strings_1.default.moveToFocusedInboxText,
            onClick: function () { return moveRowToFocusedOther(rowKeys, tableViewId); },
        });
    }
    else if (shouldShowBehaviorMap[16 /* MoveToOtherInbox */]()) {
        moveToSubMenu.push({
            key: 'moveTo' + owa_mail_strings_1.default.moveToOtherInboxText,
            name: owa_mail_strings_1.default.moveToOtherInboxText,
            onClick: function () { return moveRowToFocusedOther(rowKeys, tableViewId); },
        });
    }
    if (shouldShowBehaviorMap[0 /* AlwaysMoveToFocusedInbox */]()) {
        moveToSubMenu.push({
            key: 'moveTo' + owa_mail_strings_1.default.alwaysMoveToFocusedInboxText,
            name: owa_mail_strings_1.default.alwaysMoveToFocusedInboxText,
            onClick: function () { return alwaysMoveToFocusedOther(rowKeys, tableViewId); },
        });
    }
    else if (shouldShowBehaviorMap[1 /* AlwaysMoveToOtherInbox */]()) {
        moveToSubMenu.push({
            key: 'moveTo' + owa_mail_strings_1.default.alwaysMoveToOtherInboxText,
            name: owa_mail_strings_1.default.alwaysMoveToOtherInboxText,
            onClick: function () { return alwaysMoveToFocusedOther(rowKeys, tableViewId); },
        });
    }
    if (moveToSubMenu.length > 0) {
        moveToSubMenu.push(newDivider());
    }
    //#endregion
    var moveToFolders = getFoldersForMoveTo_1.default();
    var folders = moveToFolders.folders;
    var folderNameCountMap = owa_mail_moveto_control_1.getFolderNameToCountMap(folders);
    var _loop_1 = function (folder) {
        var folderId = folder.folderId;
        var folderDisplayName = folder.displayName;
        var parentFolderId = folder.parentFolderId;
        var folderNameToShow = folderNameCountMap[folderDisplayName.toLocaleLowerCase()] > 1 &&
            folderIdToName_1.default(parentFolderId) != 'msgfolderroot'
            ? folder.parentFolderDisplayName + '/' + folderDisplayName
            : folderDisplayName;
        moveToSubMenu.push({
            key: 'moveTo' + folderId,
            name: folderNameToShow,
            onClick: function () { return moveRows(rowKeys, tableViewId, folderId); },
        });
    };
    // VSO 13010: Refactor move to menu to have common code
    for (var _i = 0, folders_1 = folders; _i < folders_1.length; _i++) {
        var folder = folders_1[_i];
        _loop_1(folder);
    }
    return moveToSubMenu;
}
/**
 * Function that calls the actual triage action
 * @param rowKeys to perform action on
 * @param tableViewId where the action is being performed
 */
function moveRowToFocusedOther(rowKeys, tableViewId) {
    lazyTriageActions.lazyMoveMailListRowsToFocusedOrOther.importAndExecute(rowKeys, tableViewId, 'ContextLV');
}
/**
 * Function that calls the actual triage action
 * @param rowKeys to perform action on
 * @param tableViewId where the action is being performed
 */
function alwaysMoveToFocusedOther(rowKeys, tableViewId) {
    lazyTriageActions.lazyAlwaysMoveRowToFocusedOrOther.importAndExecute(rowKeys, owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId), 'ContextLV');
}
/**
 * Moves the given rows to a specified folder
 * @param rowKeys - the row keys to be moved
 * @param originalTableId - the origin folder
 * @param destinationFolderId - the destination folder
 */
function moveRows(rowKeys, originalTableId, destinationFolderId) {
    lazyTriageActions.lazyMoveMailListRows.importAndExecute(rowKeys, destinationFolderId, originalTableId, 'ContextLV');
}
/**
 * Called when user clicks on the reply menu item
 * @param rowKey the row key
 * @param tableViewId the table view id
 */
function onReplyRow(rowKey, tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var groupId = owa_group_selection_1.getGroupId(tableView);
    var rowId = owa_mail_list_store_1.MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
    var instrumentationContexts;
    if (tableView.tableQuery.type == 1 /* Search */) {
        instrumentationContexts = getInstrumentationContextsFromTableView_1.default([rowKey], tableView);
    }
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            owa_mail_message_actions_1.lazyReplyToConversation.importAndExecute(rowId, false /*isReplyAll*/, 'ContextLV', instrumentationContexts, groupId, isReadingPaneBottom_1.default() /*isFullCompose*/);
            break;
        case 1 /* Message */:
            owa_mail_message_actions_1.lazyReplyToItem.importAndExecute(rowId, false /* isReplyAll */, instrumentationContexts, groupId);
    }
}
/**
 * Called when user clicks on the reply all menu item
 * @param rowKey the row key
 * @param tableViewId the table view id
 */
function onReplyAllRow(rowKey, tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var groupId = owa_group_selection_1.getGroupId(tableView);
    var rowId = owa_mail_list_store_1.MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
    var instrumentationContexts;
    if (tableView.tableQuery.type == 1 /* Search */) {
        instrumentationContexts = getInstrumentationContextsFromTableView_1.default([rowKey], tableView);
    }
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            owa_mail_message_actions_1.lazyReplyToConversation.importAndExecute(rowId, true /*isReplyAll*/, 'ContextLV', instrumentationContexts, groupId, isReadingPaneBottom_1.default() /*isFullCompose*/);
            break;
        case 1 /* Message */:
            owa_mail_message_actions_1.lazyReplyToItem.importAndExecute(rowId, true /* isReplyAll */, instrumentationContexts, groupId);
    }
}
/**
 * Called when user clicks on the forward menu item
 * @param rowKey the row key
 * @param tableViewId the table view id
 */
function onForwardRow(rowKey, tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var groupId = owa_group_selection_1.getGroupId(tableView);
    var rowId = owa_mail_list_store_1.MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
    var instrumentationContexts;
    if (tableView.tableQuery.type == 1 /* Search */) {
        instrumentationContexts = getInstrumentationContextsFromTableView_1.default([rowKey], tableView);
    }
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            owa_mail_message_actions_1.lazyForwardConversation.importAndExecute(rowId, 'ContextLV', instrumentationContexts, groupId);
            break;
        case 1 /* Message */:
            owa_mail_message_actions_1.lazyForwardItem.importAndExecute(rowId, 'ContextLV', instrumentationContexts, groupId);
            break;
    }
}
/**
 * Create a divider which is used in the mail list context menu
 * @param shouldShow the should show behavior which indicates whether to show the context menu or not
 */
function newDivider(shouldShowBehavior) {
    return new owa_filterable_menu_1.FilterableMenuItem('-' /* name */, null /* icon */, null /* onClick */, shouldShowBehavior, null /* displayOption */, null /* disabled*/, null /* menuContent */, (dividerKey++).toString());
}
/**
 * Called when user clicks on the delete menu item
 */
function onDeleteClicked(rowKeys, tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    if (tableView.isInVirtualSelectAllMode) {
        // When in virtual selection, i.e non search and select all mode,
        // delete all in the folder
        lazyTriageActions.lazyEmptyTableView.importAndExecute(tableView, false /*isExplicitSoftDelete*/, 'ContextLV', tableView.virutalSelectAllExclusionList);
    }
    else {
        lazyTriageActions.lazyDeleteMailListRows.importAndExecute(rowKeys, tableViewId, false /*isExplicitSoftDelete*/, 'ContextLV');
    }
}
/**
 * Called when user clicks on the archive menu item
 */
function onArchiveClicked(rowKeys, tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    lazyTriageActions.lazyArchiveMailListRows.importAndExecute(rowKeys, tableView, 'ContextLV');
}
/**
 * Called when the user clicks on the "Show in immersive reader" menu item
 */
function onShowInImmersiveReaderClicked(rowKey, tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var rowId = owa_mail_list_store_1.MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            owa_mail_message_actions_1.lazyShowConversationInImmersiveReader.importAndExecute(rowId /* conversationId */);
            break;
        case 1 /* Message */:
            owa_immersive_reader_store_1.showInImmersiveReader(rowId /* itemId */);
            break;
    }
}
/**
 * Called when the user clicks on the "Open in new tab" menu item
 */
function onOpenInNewTabClicked(rowKeys, tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var instrumentationContexts = getInstrumentationContextsFromTableView_1.default(rowKeys, tableView);
    for (var i = 0; i < rowKeys.length; i++) {
        var rowId = owa_mail_list_store_1.MailRowDataPropertyGetter.getRowClientItemId(rowKeys[i], tableView);
        var subject = owa_mail_list_store_1.MailRowDataPropertyGetter.getSubject(rowKeys[i], tableView);
        owa_mail_reading_pane_store_1.lazyMoveReadingPaneToTab.importAndExecute(rowId, subject, true /*makeActive*/, instrumentationContexts[i]);
    }
}
function onMarkAsReadClicked(tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    markReadActions.lazyMarkAsReadInTable.importAndExecute('ContextLV', tableView.virutalSelectAllExclusionList /* exclusionList */, tableView.isInVirtualSelectAllMode /* isActingOnAllItemsInTable */, true /* isReadValueToSet */, tableView.selectedRowKeys.keys() /* rowKeysToActOn */, tableView);
}
function onMarkAsUnreadClicked(tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    markReadActions.lazyMarkAsReadInTable.importAndExecute('ContextLV', tableView.virutalSelectAllExclusionList, tableView.isInVirtualSelectAllMode /* isActingOnAllItemsInTable */, false /* isReadValueToSet */, tableView.selectedRowKeys.keys(), tableView);
}
function onBlockClicked(rowKeys, tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    lazyTriageActions.lazyBlockLastSendersFromTable.importAndExecute(rowKeys, tableView, 'ContextLV');
}
function markRowsAsFlagged(rowKeys, tableViewId) {
    lazyTriageActions.lazySetMailListRowsFlagState.importAndExecute(rowKeys, tableViewId, 'Flagged');
}
function markRowsAsNotFlagged(rowKeys, tableViewId) {
    lazyTriageActions.lazySetMailListRowsFlagState.importAndExecute(rowKeys, tableViewId, 'NotFlagged');
}
function onJunkNotJunkClicked(rowKeys, tableViewId, isJunkValueToSet) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    lazyTriageActions.lazyMarkRowsJunkNotJunk.importAndExecute(rowKeys, tableView, isJunkValueToSet, 'ContextLV' /* actionSource */);
}
function markRowsPinnedUnpinned(rowKeys, tableViewId, shouldMarkAsPinned) {
    lazyTriageActions.lazyMarkRowsPinnedUnpinned.importAndExecute(rowKeys, tableViewId, shouldMarkAsPinned, 'ContextLV');
}
/**
 * Called when user clicks on the create rule menu item
 */
function onCreateRuleClicked(rowKey, tableViewId) {
    // Get the sender from the single selected conversation.
    // Ensuring a single selection and that the selection
    // has an SMTP address is handled in the context menu should show behavior map
    var sender = owa_mail_list_store_1.MailRowDataPropertyGetter.getLastSenderMailbox(rowKey, owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId));
    owa_mail_rule_view_1.lazyShowInboxRuleDialog.importAndExecute(sender, 'ContextLV');
}
//# sourceMappingURL=getFilterableMailListContextMenuItems.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-list-context-menu/lib/components/getFilterableMailListContextMenuItems.js
// module id = 6021
// module chunks = 81